export interface Video {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  duration: string;
  views: number;
  likes: number;
  creator: string;
  creatorAvatar: string;
  category: string;
  categorySlug: string;
  publishedAt: string;
  tags: string[];
}

export interface VideoCategory {
  id: string;
  name: string;
  slug: string;
  description: string;
  coverImage: string;
  videoCount: number;
}

export const categories: VideoCategory[] = [
  {
    id: '1',
    name: '搞笑视频',
    slug: 'funny',
    description: '国内最热门的搞笑短视频，让你笑到停不下来',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20young%20people%20having%20fun%20laughing%20together%20in%20bright%20modern%20living%20room%2C%20warm%20natural%20lighting%2C%20candid%20joyful%20moment%2C%20soft%20warm%20tones%2C%20editorial%20lifestyle%20photography%20with%20clean%20background&width=600&height=600&seq=cat-funny-01&orientation=squarish',
    videoCount: 2840,
  },
  {
    id: '2',
    name: '创意微电影',
    slug: 'micro-film',
    description: '独立创作者拍摄的精品微电影，故事动人',
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20production%20behind%20the%20scenes%20with%20camera%20equipment%20and%20warm%20amber%20lighting%2C%20creative%20atmosphere%2C%20professional%20filmmaking%20setup%2C%20soft%20shadows%2C%20editorial%20photography%20style&width=600&height=600&seq=cat-film-01&orientation=squarish',
    videoCount: 1520,
  },
  {
    id: '3',
    name: '生活记录',
    slug: 'life',
    description: '真实生活中的温暖瞬间，记录美好日常',
    coverImage: 'https://readdy.ai/api/search-image?query=Peaceful%20Chinese%20morning%20routine%20with%20steaming%20tea%20cup%20and%20sunlight%20through%20window%2C%20cozy%20home%20interior%2C%20warm%20golden%20hour%20light%2C%20minimalist%20aesthetic%2C%20editorial%20lifestyle%20photography&width=600&height=600&seq=cat-life-01&orientation=squarish',
    videoCount: 3680,
  },
  {
    id: '4',
    name: '才艺展示',
    slug: 'talent',
    description: '国内达人秀出的惊人才艺，目不暇接',
    coverImage: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20musician%20playing%20traditional%20instrument%20on%20stage%20with%20dramatic%20warm%20spotlight%2C%20artistic%20performance%20atmosphere%2C%20elegant%20composition%2C%20soft%20bokeh%20background%2C%20editorial%20concert%20photography&width=600&height=600&seq=cat-talent-01&orientation=squarish',
    videoCount: 2100,
  },
  {
    id: '5',
    name: '美食探店',
    slug: 'food',
    description: '走遍大江南北，寻找最地道的美食故事',
    coverImage: 'https://readdy.ai/api/search-image?query=Delicious%20Chinese%20street%20food%20spread%20on%20wooden%20table%20with%20warm%20ambient%20lighting%2C%20steaming%20dishes%2C%20rich%20colors%20and%20textures%2C%20appetizing%20composition%2C%20editorial%20food%20photography%20with%20soft%20shadows&width=600&height=600&seq=cat-food-01&orientation=squarish',
    videoCount: 1950,
  },
  {
    id: '6',
    name: '旅行风景',
    slug: 'travel',
    description: '探索祖国壮丽山河，发现不一样的风景',
    coverImage: 'https://readdy.ai/api/search-image?query=Majestic%20Chinese%20mountain%20landscape%20at%20sunrise%20with%20misty%20valleys%20and%20golden%20light%2C%20dramatic%20natural%20scenery%2C%20serene%20atmosphere%2C%20wide%20panoramic%20composition%2C%20editorial%20nature%20photography&width=600&height=600&seq=cat-travel-01&orientation=squarish',
    videoCount: 1680,
  },
];

export const videos: Video[] = [
  {
    id: 'v1',
    title: '办公室里的那些尴尬瞬间，你能坚持看到第几个不笑？',
    description: '精选国内办公室爆笑瞬间合集，同事们的神操作让人忍俊不禁。从开会打瞌睡到打印机卡纸暴走的经典场面，每一个场景都真实到让人直呼"这就是我公司"。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20office%20workspace%20chaos%20scene%20with%20scattered%20papers%20and%20overturned%20coffee%20cup%2C%20warm%20indoor%20lighting%2C%20comedic%20candid%20moment%2C%20soft%20natural%20tones%2C%20editorial%20lifestyle%20photography&width=800&height=450&seq=vid-01&orientation=landscape',
    duration: '3:42',
    views: 2450000,
    likes: 128000,
    creator: '爆笑研究所',
    creatorAvatar: 'https://readdy.ai/api/search-image?query=Friendly%20young%20Chinese%20man%20smiling%20portrait%20with%20clean%20minimal%20background%2C%20warm%20natural%20lighting%2C%20approachable%20expression%2C%20soft%20tones%2C%20editorial%20headshot%20photography&width=100&height=100&seq=avatar-01&orientation=squarish',
    category: '搞笑视频',
    categorySlug: 'funny',
    publishedAt: '2026-06-28',
    tags: ['搞笑', '办公室', '日常'],
  },
  {
    id: 'v2',
    title: '北漂女孩的一天：在拥挤地铁里追逐梦想',
    description: '一部触动人心的微纪录片，真实记录一位在北京打拼的年轻女孩的一天。从清晨六点的闹钟，到深夜回家的末班地铁，每个镜头都充满了生活的温度。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20walking%20alone%20on%20city%20street%20at%20dusk%20with%20warm%20street%20lights%20bokeh%2C%20contemplative%20mood%2C%20urban%20atmosphere%2C%20soft%20golden%20tones%2C%20editorial%20documentary%20photography&width=800&height=450&seq=vid-02&orientation=landscape',
    duration: '8:15',
    views: 1890000,
    likes: 95000,
    creator: '城市微光',
    creatorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20with%20confident%20expression%20portrait%2C%20clean%20minimal%20background%2C%20warm%20natural%20lighting%2C%20modern%20creative%20professional%20look%2C%20editorial%20headshot%20photography&width=100&height=100&seq=avatar-02&orientation=squarish',
    category: '创意微电影',
    categorySlug: 'micro-film',
    publishedAt: '2026-06-25',
    tags: ['微电影', '北漂', '励志'],
  },
  {
    id: 'v3',
    title: '90后妈妈带娃日常：崩溃与治愈的边缘反复横跳',
    description: '最真实的育儿vlog，没有滤镜，没有剧本。从早餐世界大战到睡前故事时光，记录一位90后妈妈与两岁萌娃的日常战斗与温馨时刻。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cozy%20Chinese%20family%20living%20room%20with%20mother%20and%20toddler%20playing%20together%20on%20floor%2C%20warm%20natural%20window%20light%2C%20toys%20scattered%20around%2C%20joyful%20domestic%20moment%2C%20editorial%20lifestyle%20photography&width=800&height=450&seq=vid-03&orientation=landscape',
    duration: '5:28',
    views: 3200000,
    likes: 210000,
    creator: '暖暖妈日记',
    creatorAvatar: 'https://readdy.ai/api/search-image?query=Warm%20smiling%20young%20Chinese%20mother%20portrait%20with%20soft%20natural%20lighting%2C%20clean%20background%2C%20gentle%20expression%2C%20warm%20tones%2C%20editorial%20headshot%20photography&width=100&height=100&seq=avatar-03&orientation=squarish',
    category: '生活记录',
    categorySlug: 'life',
    publishedAt: '2026-06-22',
    tags: ['育儿', '日常', 'vlog'],
  },
  {
    id: 'v4',
    title: '大学生在宿舍演绎经典影视剧名场面，演技炸裂！',
    description: '一群热爱表演的大学生，用简陋的宿舍场景和无穷的创意，神还原了多部经典影视剧的经典片段。道具虽简，演技却足以碾压流量明星。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Creative%20Chinese%20college%20dorm%20room%20with%20students%20rehearsing%20drama%20performance%2C%20warm%20indoor%20lighting%2C%20casual%20youthful%20energy%2C%20colorful%20posters%20on%20wall%2C%20editorial%20lifestyle%20photography&width=800&height=450&seq=vid-04&orientation=landscape',
    duration: '6:33',
    views: 1560000,
    likes: 87000,
    creator: '戏精宿舍',
    creatorAvatar: 'https://readdy.ai/api/search-image?query=Energetic%20young%20Chinese%20male%20student%20portrait%20with%20playful%20expression%2C%20clean%20minimal%20background%2C%20warm%20natural%20lighting%2C%20creative%20youthful%20vibe%2C%20editorial%20headshot%20photography&width=100&height=100&seq=avatar-04&orientation=squarish',
    category: '才艺展示',
    categorySlug: 'talent',
    publishedAt: '2026-06-20',
    tags: ['才艺', '大学生', '表演'],
  },
  {
    id: 'v5',
    title: '凌晨四点的重庆火锅：一座城市的不夜滋味',
    description: '深入重庆凌晨的火锅店，探寻这座山水之城最地道的夜生活味道。从沸腾的红汤到毛肚的七上八下，每一帧都是舌尖上的中国。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Steaming%20hot%20Chinese%20hot%20pot%20close%20up%20with%20red%20spicy%20broth%20and%20fresh%20ingredients%2C%20warm%20ambient%20restaurant%20lighting%2C%20appetizing%20food%20photography%2C%20rich%20colors%2C%20editorial%20culinary%20photography&width=800&height=450&seq=vid-05&orientation=landscape',
    duration: '4:56',
    views: 2780000,
    likes: 156000,
    creator: '味蕾探险家',
    creatorAvatar: 'https://readdy.ai/api/search-image?query=Friendly%20middle%20aged%20Chinese%20man%20chef%20with%20warm%20smile%20portrait%2C%20clean%20background%2C%20natural%20lighting%2C%20approachable%20expression%2C%20editorial%20headshot%20photography&width=100&height=100&seq=avatar-05&orientation=squarish',
    category: '美食探店',
    categorySlug: 'food',
    publishedAt: '2026-06-18',
    tags: ['美食', '重庆', '火锅'],
  },
  {
    id: 'v6',
    title: ' Kashmir 不是国外：西藏秘境的纯净之美',
    description: '自驾穿越西藏无人区，用镜头记录下这片被称为"世界屋脊"的土地最原始的模样。冰川、圣湖、经幡，每一帧都是壁纸级的美景。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Pristine%20Tibetan%20highland%20landscape%20with%20snow%20capped%20mountains%20and%20crystal%20clear%20lake%2C%20prayer%20flags%20fluttering%20in%20wind%2C%20dramatic%20golden%20hour%20light%2C%20epic%20natural%20scenery%2C%20editorial%20travel%20photography&width=800&height=450&seq=vid-06&orientation=landscape',
    duration: '7:22',
    views: 4120000,
    likes: 280000,
    creator: '远方影像',
    creatorAvatar: 'https://readdy.ai/api/search-image?query=Adventurous%20young%20Chinese%20man%20with%20outdoor%20gear%20portrait%2C%20confident%20expression%2C%20clean%20minimal%20background%2C%20warm%20natural%20lighting%2C%20editorial%20headshot%20photography&width=100&height=100&seq=avatar-06&orientation=squarish',
    category: '旅行风景',
    categorySlug: 'travel',
    publishedAt: '2026-06-15',
    tags: ['西藏', '旅行', '风景'],
  },
  {
    id: 'v7',
    title: '学霸弟弟给姐姐辅导功课，结果姐姐一个都没听懂',
    description: '姐弟俩的学习日常，弟弟明明是学霸却教不会姐姐一道题。从耐心讲解到逐渐崩溃的过程，让无数网友直呼"太真实了"。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20teenage%20siblings%20studying%20together%20at%20desk%20with%20books%20and%20laptop%2C%20warm%20home%20lighting%2C%20one%20focused%20one%20confused%20expression%2C%20casual%20domestic%20scene%2C%20editorial%20lifestyle%20photography&width=800&height=450&seq=vid-07&orientation=landscape',
    duration: '2:45',
    views: 1980000,
    likes: 134000,
    creator: '家有学渣',
    creatorAvatar: 'https://readdy.ai/api/search-image?query=Cheerful%20Chinese%20teenage%20boy%20with%20glasses%20portrait%2C%20smart%20expression%2C%20clean%20minimal%20background%2C%20warm%20natural%20lighting%2C%20editorial%20headshot%20photography&width=100&height=100&seq=avatar-07&orientation=squarish',
    category: '搞笑视频',
    categorySlug: 'funny',
    publishedAt: '2026-06-12',
    tags: ['搞笑', '姐弟', '学习'],
  },
  {
    id: 'v8',
    title: '老人与猫：一个关于陪伴的感人短片',
    description: '没有一句台词的微电影，只用画面讲述了一位独居老人和一只流浪猫之间的温暖故事。三分钟，足以让你泪目。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elderly%20Chinese%20man%20sitting%20peacefully%20on%20porch%20with%20orange%20cat%20on%20lap%2C%20warm%20late%20afternoon%20sunlight%2C%20serene%20countryside%20setting%2C%20emotional%20cinematic%20composition%2C%20editorial%20documentary%20photography&width=800&height=450&seq=vid-08&orientation=landscape',
    duration: '3:18',
    views: 3450000,
    likes: 245000,
    creator: '光影故事',
    creatorAvatar: 'https://readdy.ai/api/search-image?query=Thoughtful%20young%20Chinese%20filmmaker%20with%20camera%20portrait%2C%20creative%20expression%2C%20clean%20minimal%20background%2C%20warm%20natural%20lighting%2C%20editorial%20headshot%20photography&width=100&height=100&seq=avatar-08&orientation=squarish',
    category: '创意微电影',
    categorySlug: 'micro-film',
    publishedAt: '2026-06-10',
    tags: ['微电影', '温情', '老人'],
  },
  {
    id: 'v9',
    title: '小伙在乡村开了间咖啡馆，没想到火了',
    description: '辞去大城市工作，回到老家村子里开了一家咖啡馆。从无人问津到网红打卡地，他用一杯杯咖啡连接起了城市和乡村。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cozy%20rustic%20cafe%20interior%20in%20Chinese%20village%20with%20wooden%20furniture%20and%20warm%20natural%20light%2C%20barista%20preparing%20coffee%2C%20quaint%20charming%20atmosphere%2C%20editorial%20lifestyle%20photography&width=800&height=450&seq=vid-09&orientation=landscape',
    duration: '5:47',
    views: 2670000,
    likes: 178000,
    creator: '乡村咖啡师',
    creatorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20with%20casual%20style%20and%20warm%20smile%20portrait%2C%20clean%20minimal%20background%2C%20natural%20lighting%2C%20approachable%20creative%20vibe%2C%20editorial%20headshot%20photography&width=100&height=100&seq=avatar-09&orientation=squarish',
    category: '生活记录',
    categorySlug: 'life',
    publishedAt: '2026-06-08',
    tags: ['创业', '乡村', '咖啡'],
  },
];

export const featuredCreators = [
  {
    id: 'c1',
    name: '爆笑研究所',
    avatar: 'https://readdy.ai/api/search-image?query=Funny%20young%20Chinese%20content%20creator%20with%20exaggerated%20comedic%20expression%20portrait%2C%20colorful%20casual%20style%2C%20clean%20background%2C%20warm%20natural%20lighting%2C%20editorial%20headshot%20photography&width=200&height=200&seq=feat-avatar-01&orientation=squarish',
    location: '北京',
    followers: '245万',
    videos: 342,
    description: '专注于挖掘生活中的爆笑瞬间，用最真实的镜头记录最荒诞的日常。',
  },
  {
    id: 'c2',
    name: '城市微光',
    avatar: 'https://readdy.ai/api/search-image?query=Artistic%20young%20Chinese%20female%20filmmaker%20with%20thoughtful%20expression%20portrait%2C%20clean%20minimal%20style%2C%20warm%20natural%20lighting%2C%20creative%20professional%20vibe%2C%20editorial%20headshot%20photography&width=200&height=200&seq=feat-avatar-02&orientation=squarish',
    location: '上海',
    followers: '189万',
    videos: 156,
    description: '用镜头讲述城市角落里那些不为人知的故事，每一部都是用心之作。',
  },
  {
    id: 'c3',
    name: '远方影像',
    avatar: 'https://readdy.ai/api/search-image?query=Adventurous%20young%20Chinese%20travel%20photographer%20with%20outdoor%20gear%20and%20backpack%20portrait%2C%20confident%20expression%2C%20clean%20background%2C%20warm%20natural%20lighting%2C%20editorial%20headshot%20photography&width=200&height=200&seq=feat-avatar-03&orientation=squarish',
    location: '成都',
    followers: '412万',
    videos: 89,
    description: '足迹遍布中国每一个角落，用影像记录这片土地的壮美与温柔。',
  },
];

export const testimonials = [
  {
    id: 't1',
    content: '国产91视频是我每天必刷的平台，这里的创作者真的很有才华。不像其他平台全是同质化内容，这里的每一条视频都能感受到创作者的用心。',
    author: '李小明',
    role: '资深视频爱好者',
  },
  {
    id: 't2',
    content: '作为一个独立 filmmaker，国产91视频给了我展示作品的舞台。平台对原创内容的尊重和支持，让我能专注于创作而不必担心流量焦虑。',
    author: '张导演',
    role: '独立电影创作者',
  },
  {
    id: 't3',
    content: '在这里发现了很多宝藏创作者，从搞笑到微电影，从美食到旅行，每一个分类都有惊喜。而且界面很干净，看视频的体验非常舒服。',
    author: '王小红',
    role: '平台忠实用户',
  },
];

export const formatViews = (num: number): string => {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1)}百万`;
  }
  if (num >= 10000) {
    return `${(num / 10000).toFixed(0)}万`;
  }
  return num.toLocaleString();
};